import { retryLazy } from '@utils/Lazy';
// 로그인/계정
const LoginPage = retryLazy(() => import('@pages/auth/LoginPage'));
const FindUserPage = retryLazy(() => import('@pages/auth/FindUserPage'));
const FindPasswordPage = retryLazy(() =>
  import('@pages/auth/FindPasswordPage'),
);
const JoinTypePage = retryLazy(() => import('@pages/auth/JoinTypePage'));
const JoinPage = retryLazy(() => import('@pages/auth/JoinPage'));

const HomePage = retryLazy(() => import('@pages/home/HomePage'));
const InquiryPage = retryLazy(() => import('@pages/inquiry/InquiryPage'));
const CompanyPage = retryLazy(() => import('@pages/setting/CompanyPage'));
const TravelGroupPage = retryLazy(() =>
  import('@app/pages/setting/TravelGroupPage'),
);
const EmployeePage = retryLazy(() => import('@app/pages/setting/EmployeePage'));
const SupportPage = retryLazy(() => import('@app/pages/setting/SupportPage'));
const StaticsCompanyPage = retryLazy(() =>
  import('@app/pages/statics/StaticsCompanyPage'),
);

const MobileHomePage = retryLazy(() =>
  import('@app/pages/mobile/home/MobileHomePage'),
);
const MobileNotificationsPage = retryLazy(() =>
  import('@pages/mobile/notifications/MobileNotificationsPage'),
);
const MobileInquiryPage = retryLazy(() =>
  import('@pages/mobile/inquiry/MobileInquiryPage'),
);

const MobileInquiryDtaile = retryLazy(() =>
  import('@pages/mobile/inquiry/MobileInquiryDtaile'),
);
const MobileChatPage = retryLazy(() =>
  import('@app/pages/mobile/chat/MobileChatPage'),
);
const MobileChatDetailImagesPage = retryLazy(() =>
  import('@app/pages/mobile/chat/MobileChatDetailImagesPage'),
);
const MobileInquiryRoomChargesPage = retryLazy(() =>
  import('@pages/mobile/inquiry/MobileInquiryRoomChargesPage'),
);
const MobileInquiryWorkHistoriesPage = retryLazy(() =>
  import('@pages/mobile/inquiry/MobileInquiryWorkHistoriesPage'),
);
const MobileInquiryTravelDetailPage = retryLazy(() =>
  import('@app/pages/mobile/inquiry/MobileInquiryTravelDetailPage'),
);
const MobileTravelGroupPage = retryLazy(() =>
  import('@app/pages/mobile/setting/MobileTravelGroupPage'),
);
const MobileSupportPage = retryLazy(() =>
  import('@app/pages/mobile/setting/MobileSupportPage'),
);
const EmptyLayout = retryLazy(() => import('@components/layout/EmptyLayout'));
const MainLayout = retryLazy(() => import('@components/layout/MainLayout'));

const authRoutes = [
  {
    layout: MainLayout,
    contents: [
      {
        key: 'home',
        path: '/home',
        name: 'home',
        component: HomePage,
      },
      {
        key: 'inquiry',
        path: '/inquiry',
        name: '객실 문의',
        component: InquiryPage,
      },
      {
        key: 'company',
        path: '/setting/company',
        name: '회사 정보 관리',
        component: CompanyPage,
      },
      {
        key: 'travel-group',
        path: '/setting/travel-group',
        name: '여행사 그룹 관리',
        component: TravelGroupPage,
      },
      {
        key: 'employee',
        path: '/setting/employee',
        name: '직원 관리',
        component: EmployeePage,
      },
      {
        key: 'support',
        path: '/setting/support',
        name: '고객센터',
        component: SupportPage,
      },
      {
        key: 'company-statics',
        path: '/statics/company',
        name: '호텔 통계',
        component: StaticsCompanyPage,
      },
    ],
  },
];

const noAuthRoutes = [
  {
    layout: EmptyLayout,
    contents: [
      {
        key: 'login',
        path: '/login',
        name: '로그인',
        component: LoginPage,
      },
      {
        key: 'joinType',
        path: '/join/type',
        name: '가입 타입',
        component: JoinTypePage,
      },
      {
        key: 'join',
        path: '/join',
        name: '회원가입',
        component: JoinPage,
      },
      {
        key: 'findUser',
        path: '/find/user',
        name: '아이디 찾기',
        component: FindUserPage,
      },
      {
        key: 'login',
        path: '/find/password',
        name: '비밀번호 찾기',
        component: FindPasswordPage,
      },
    ],
  },
];

const mobileAuthRoutes = [
  {
    path: 'home',
    layout: EmptyLayout, // 필요한 레이아웃이 있으면 사용, 기본은 각 컴포넌트에서 모바일 페이지 컨테이너 사용
    children: [{ path: '', component: MobileHomePage }],
  },
  {
    path: 'notifications',
    layout: EmptyLayout, // 필요한 레이아웃이 있으면 사용, 기본은 각 컴포넌트에서 모바일 페이지 컨테이너 사용
    children: [{ path: '', component: MobileNotificationsPage }],
  },
  {
    path: 'chat',
    layout: EmptyLayout, // 필요한 레이아웃이 있으면 사용, 기본은 각 컴포넌트에서 모바일 페이지 컨테이너 사용,
    children: [
      { path: ':id', component: MobileChatPage },
      { path: ':id/seq/:seq', component: MobileChatDetailImagesPage },
    ],
  },
  {
    path: 'inquiry',
    layout: EmptyLayout,
    children: [
      { path: '', component: MobileInquiryPage },
      { path: ':id', component: MobileInquiryDtaile },
      { path: ':id/roomCharges', component: MobileInquiryRoomChargesPage },
      { path: ':id/workHistories', component: MobileInquiryWorkHistoriesPage },
      {
        path: ':id/travelDetail/:travelId',
        component: MobileInquiryTravelDetailPage,
      },
    ],
  },
  {
    path: 'setting',
    layout: EmptyLayout,
    children: [
      { path: 'travel-group', component: MobileTravelGroupPage },
      { path: 'support', component: MobileSupportPage },
    ],
  },
];

const defaultPath = '/login';
const routes = { noAuthRoutes, authRoutes, defaultPath, mobileAuthRoutes };

export default routes;
